module.exports = __webpack_public_path__ + "img/help-active.5b7b7b29.svg";